import { render, staticRenderFns } from "./JoinNameView.vue?vue&type=template&id=2731d274&scoped=true&"
import script from "./JoinNameView.vue?vue&type=script&lang=js&"
export * from "./JoinNameView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2731d274",
  null
  
)

export default component.exports